import React, { Component } from 'react';
import { connect } from "react-redux";
import {getBarWidth} from './getBarWidth.js';
import {DEFAULT_RESOLUTION} from './constants.js';

function RowSelection(props) {
    let style = {
        left: getBarWidth(props.start, props.resolution, props.xScale),
        width: getBarWidth(props.end - props.start, props.resolution, props.xScale),
    };
    return (
        <div
          style={style}
          className="row-selection">
        </div>
    );
}

const mapStateToProps = (state, props) => {
    let selection = state.arrangement.rowSelections[props.id];
    return {
        start: selection === undefined ? 0 : selection.start,
        end: selection === undefined ? 0 : selection.end,
        resolution: DEFAULT_RESOLUTION,
        xScale: state.arrangement.xScale,
    };
};
 
export default connect(mapStateToProps, null)(RowSelection);
